import product1 from './assets/a3.png';
import product2 from './assets/a4.png';
import product3 from './assets/a2.png';
import product4 from './assets/a1.png';
import product5 from './assets/fram4.png';
import product6 from './assets/Frame3.png';
import product7 from './assets/a5.png';
import product8 from './assets/img8.png';


export const PRODUCTS = [
    {
        id:1,
        productName: "Strawberry Cow Earrings",
        price: 18.00,
        productImage: product1,
    },
    {
        id:2,
        productName: "Happy Frog Earrings",
        price: 15.00,
        productImage: product2,
    },
    {
        id:3,
        productName: "Pink Bunny Earrings",
        price: 18.00,
        productImage: product3,
    },
    {
        id:4,
        productName: "Fluffy Sheep Earrings",
        price: 15.00,
        productImage: product4,
    },
    {
        id:5,
        productName: "Straw-bear Earrings",
        price: 15.00,
        productImage: product5,
    },
    {
        id:6,
        productName: "Rose Cow Earrings",
        price: 18.00,
        productImage: product6,
    },
    {
        id:7,
        productName: "Regular Cow Earrings",
        price: 15.00,
        productImage: product7,
    }
]